import React from "react";
import { bool, number, object, string } from "prop-types";
import { ListView as StorybookListView } from "@sunbeltrentals/sbr-global-components";
import { useCartState } from "../../../../contexts/cart";
import RequiredAccessoriesAddonsInfoModal from "../requiredAccessoriesAddonsInfoModal/RequiredAccessoriesAddonsInfoModal";
import RentalItem from "./components/RentalItem";
import "./RequiredAccessoriesAddonsDetails.scss";

const RequiredAccessoriesAddonsDetails = (props) => {
  const {
    isModalView = false,
    title = "",
    forcedItemsDetails = {},
    mainProductQty = 1
  } = props || {};
  const [{ accessoriesRates }] = useCartState();
  const forceItems = [...(forcedItemsDetails?.addons || []), ...(forcedItemsDetails?.rentals || [])];

  const getPrice = item => {
      return parseFloat(accessoriesRates[item?.sku]?.rates?.suggestedRates?.daily || item?.sellingPrice || 0) * mainProductQty;
  };

  const getConsumablesList = () => {
      const data = forceItems?.map(item => (
          <RentalItem
              key={item?.sku}
              name={item?.name}
              sellingPrice={getPrice(item)}
              isModalView={isModalView}
              minQuantity={mainProductQty}
          />
      ));
      return (
          <StorybookListView
              columns={1}
              itemsPerColumn={2}
              data={data}
              customClassColumn={'rental_details_columns'}
              shouldHideLastLine={!isModalView}
          />
      );
  };

  return (
    <>
      <div className="card_rentals">
        <h5 className="card_rentals_title">{title}</h5>
        {!isModalView && <RequiredAccessoriesAddonsInfoModal title={title} isModalView={isModalView} />}
      </div>
      {getConsumablesList()}
    </>
  );
};

RequiredAccessoriesAddonsDetails.propTypes = {
  isModalView: bool,
  forcedItemsDetails: object,
  title: string,
  mainProductQty: number
};

export default React.memo(RequiredAccessoriesAddonsDetails);
